// Consultation/FindPsychologistButtonsBox.tsx

import React from 'react';
import Button from 'Core/components/elements/Button/Button';
import {useNavigate} from 'react-router-dom';
import {useTheme} from 'Theme/ThemeContext';
import {FC} from "WideLayout/Layouts";

interface FindPsychologistButtonsBoxProps {
    cls?: string;  // Объявление типа для пропса cls (необязательный)
}

const FindPsychologistButtonsBox: React.FC<FindPsychologistButtonsBoxProps> = ({cls = ''}) => {
    const navigate = useNavigate();
    const {plt} = useTheme();

    return (
        <FC g={1} cls={cls}>
            <Button
                className="text-nowrap px-4"
                style={{
                    backgroundColor: plt.colors.secondary.main,
                    color: plt.text.contrast,
                }}
                onClick={() => navigate('/questionnaire/personal')}
                size={'small'}
            >
                ПОДОБРАТЬ ПСИХОЛОГА
            </Button>
            <Button
                className="text-nowrap px-4"
                style={{
                    backgroundColor: plt.colors.secondary.main,
                    color: plt.text.contrast,
                }}
                onClick={() => navigate('/psychologists/favorites')}
                size={'small'}
            >
                Выбрать из избранного
            </Button>
        </FC>
    );
};

export default FindPsychologistButtonsBox;
